import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { PermissionsPermissions } from '@app/core/permissions';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import {
    IBuildProgrammeTemplateDto,
    BuildProgrammeTemplateLogicService,
    BuildProgrammeTemplateMappedItem
} from '@app/logic/build-programme-template';
import { BuildProgrammeTemplateDialogComponent } from './build-programme-template-dialog/build-programme-template-dialog.component';
import moment from 'moment';
import { take } from 'rxjs';

@Component({
    selector: 'cb-build-programme-templates',
    templateUrl: './build-programme-templates.component.html',
    styleUrls: ['./build-programme-templates.component.scss'],
    standalone: false
})
export class BuildProgrammeTemplatesComponent extends BaseSimpleListViewDirective<IBuildProgrammeTemplateDto, BuildProgrammeTemplateLogicService> {

    constructor(
        public readonly cbDialog: CbDialogService,
        public readonly permissionsPermissions: PermissionsPermissions,
        protected readonly buildProgrammeTemplateLogicService: BuildProgrammeTemplateLogicService,
        protected readonly navigationService: NavigationService,
    ) {
        super(
            cbDialog,
            buildProgrammeTemplateLogicService,
            BuildProgrammeTemplateDialogComponent,
            'Build Programme Template',
            BuildProgrammeTemplateMappedItem,
            permissionsPermissions,
        );
    }

    public sortSearchResults(searchResults: IBuildProgrammeTemplateDto[]): IBuildProgrammeTemplateDto[] {
        return searchResults.sort((a, b) => moment.utc(a.updatedDate).diff(moment.utc(b.updatedDate)));
    }

    public viewTemplateClicked(dto: IBuildProgrammeTemplateDto): void {
        this.navigationService.navigate([`/build-programme-templates/view/${dto.id}/template`]);
    }

    public duplicateItemClicked(dto: IBuildProgrammeTemplateDto): MatDialogRef<BuildProgrammeTemplateDialogComponent> {
        const newMappedItem = this.logicService.$createMappedItem(dto, BuildProgrammeTemplateMappedItem);
        newMappedItem.id = undefined;
        newMappedItem.name = `Copy of ${newMappedItem.name}`;
        newMappedItem.buildProgrammeTemplateId = dto.id;

        const dialog = this.cbDialog.open(BuildProgrammeTemplateDialogComponent, {
            data: {
                dialogHeading: 'Duplicate Build Programme Template',
                mappedItem: newMappedItem,
                baseTemplateName: dto.name
            },
        });
        dialog.afterClosed().pipe(take(1)).subscribe((item: BuildProgrammeTemplateMappedItem) => this.handleNewItem(item));
        return dialog;
    }

    protected handleNewItem(item: BuildProgrammeTemplateMappedItem): void {
        this.getSearchResults().pipe(take(1)).subscribe(x => this.handleSearchResults(x));
    }

    public handleEditItem = (item: BuildProgrammeTemplateMappedItem): void => {
        this.getSearchResults().pipe(take(1)).subscribe(x => this.handleSearchResults(x));
    };


}
